import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#2e7d32', color: '#fff', mt: 5 }}>
      {/* Main Footer */}
      <Container sx={{ py: 4 }}>
        <Grid container spacing={4}>
          
          {/* Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box>
              <Link href="/" color="inherit" underline="hover" display="block">Home</Link>
              <Link href="/about-journal" color="inherit" underline="hover" display="block">About</Link>
              <Link href="/archives" color="inherit" underline="hover" display="block">Archives</Link>
              <Link href="/announcements" color="inherit" underline="hover" display="block">Announcements</Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2">Email: info@sabuddhiresearch.org / sabuddhiresearch@gmail.com</Typography>
            <Typography variant="body2">Phone: +94777266315/+94710535566 </Typography>
            <Typography variant="body2">Lake Crest, 2E/U03/F03, Madawila, Angoda, Sri Lanka.</Typography>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{ backgroundColor: '#fff', opacity: 0.2 }} />

      {/* Bottom bar */}
      <Box sx={{ textAlign: 'center', py: 2, backgroundColor: '#256429' }}>
        <Typography variant="body2">
          © {new Date().getFullYear()} Sabudhdhi Research  (Online). All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
